import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { ContractDetails } from '~/modules/contract/single';

import { getSchemaDefaults } from '@vestigas/utils';
import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

import { getContract } from './-routeParams';
import { zodContractSearchParamsSchema } from './-searchParams';

const title = i18n.t(($) => $.pageTitle, {
  contractNumber: '',
  ns: 'contract',
});

export const Route = createFileRoute('/(main)/demand/contracts/$contractId/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/contracts/$contractId',
    ...routeParams,
  }),
  component: ContractDetails,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(
      `${title} ${loaderData?.pageData?.title ?? ''}`,
      'Verwalte deinen Vertrag in VESTIGAS',
    ),
  loader: async ({ context, params }) => {
    const contractContext = await getContract({ context, params });
    return contractContext;
  },
  search: {
    middlewares: [
      stripSearchParams(getSchemaDefaults(zodContractSearchParamsSchema)),
    ],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodContractSearchParamsSchema,
});

export const DEMAND_CONTRACT = buildRouteExport({ Route, ...routeParams });
